import { render, staticRenderFns } from "./ModalPrecioExtra.vue?vue&type=template&id=e207664c&"
import script from "./ModalPrecioExtra.vue?vue&type=script&lang=js&"
export * from "./ModalPrecioExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports